/* template */
<template><div :class='("container "+(type))'><div class="title"><hl-text :text="(contents.title)"/></div><div class="sub-title"><hl-text :hlStyle="(hlStyle)" :text="(contents.subTitle)"/></div><mpx-image mode="widthFix" :src="(contents.pic)" class="chart"></mpx-image><div :class='("chart-text "+(contents.noTicketStatus ? "no" : "yes"))'><span class="time-start">当前时间</span><span class="time-end">{{ contents.showTime }}</span></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6dda46bb"}'>
  .container
    width 375px
    max-width 100%
    box-sizing border-box
    line-height 1
    font-weight normal
    padding 29px 20px 0
    .title
      font-family PingFangSC-Semibold
      font-size 22px
    .sub-title
      font-family PingFangSC-Medium
      font-size 16px
      margin 48px 0 43px
    .chart
      width 100%
    .chart-text
      @extend .flex-center
      justify-content space-between
      position relative
      height 66px
      .time-start, .time-end
        font-family PingFangSC-Regular
        font-size 12px
        color #666666
        position absolute
        top 8px
      .time-start
        left 31.49%
        transform translateX(-50%)
      .time-end
        right 24.18%
        transform translateX(50%)
    .yes>.time-start, .no>.time-end
      font-family PingFangSC-Medium
      color #333
    .yes
      .time-start
        left 24.92%
      .time-end
        right 0
        transform none
  .container.popup
    .sub-title
      margin 12px 0 32px
    .chart-text
      height auto
    .time-start
      left 17.46%
    .time-end
      right 20.68%
    .yes
      .time-start
        left 21.69%
      .time-end
        right 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6dda46bb"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./content.mpx.js?isComponent&outputPath=components%2Fcontent6dda46bb%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./content.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcontent6dda46bb%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6dda46bb"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/content6dda46bb/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'hl-text':getComponent(require("../hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
